import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleGroupStatus = createAsyncThunk('groups/toggleActive', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/group/toggleActive', id)

  return results
})